import PropTypes from 'prop-types';

import { HStack } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';

import SidebarMainHeaderCloseButton from 'shared/components/Sidebar/Button/SidebarMainHeaderCloseButton';
import SidebarHeaderContainer from 'shared/components/Sidebar/Header/SidebarHeaderContainer';
import SidebarHeaderTitle from 'shared/components/Sidebar/Header/SidebarHeaderTitle';

export const SidebarMainHeaderPropTypes = {
  /**
   * Children to render to the right of the header. It could be a button or a dropdown.
   * @type {node}
   * @name children
   * @example <SidebarMainHeader title="Filters"> <Button>Apply</Button> </SidebarMainHeader>
   * @example <SidebarMainHeader title="Filters"> <Dropdown> <DropdownItem>Apply</DropdownItem> </Dropdown> </SidebarMainHeader>
   */
  children: PropTypes.node,
  /**
   * Sidebar title.
   * @type {string}
   * @required
   * @name title
   * @example <SidebarMainHeader title="Filters" />
   */
  title: PropTypes.string.isRequired,
};

const SidebarMainHeader = ({ children = null, title }) => (
  <Box style={{ backgroundColor: 'var(--bgPrimary)' }}>
    <SidebarHeaderContainer>
      <HStack>
        <SidebarMainHeaderCloseButton />
        <SidebarHeaderTitle>{title}</SidebarHeaderTitle>
      </HStack>
      {children}
    </SidebarHeaderContainer>
  </Box>
);

SidebarMainHeader.propTypes = SidebarMainHeaderPropTypes;

export default SidebarMainHeader;
